import React, { ReactElement } from 'react';
import { Spinner } from '@erecruit/ui-kit';
import { styled } from '@erecruit/ui-kit';

const SpinnerContainer = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
}));

const LoadingPage = (): ReactElement => (
  <SpinnerContainer>
    <Spinner size="large" tip="Loading ..." />
  </SpinnerContainer>
);

export default LoadingPage;
